// extracted by mini-css-extract-plugin
export default {"customWidth":"Login_customWidth__QQi4a","defLink":"Login_defLink__TVMFh"};